<template>
  <div class="local-container" v-show="showing(['controls', 'chat'])">
    <room-controls
      :room="room"
      :joining-room="joiningRoom"
      :disabled="disabled"
      @join="join"
      @disconnect="disconnect"
      v-show="showing('controls')"
    />
    <room-chat
      :participants="participants"
      :roomInstance="room"
      :disabled="disabled"
      :visible="showing('chat')"
      v-show="showing('chat')"
    />
  </div>
</template>

<script>
import RoomControls from './RoomControls';
import RoomChat from '@/components/rooms/components/roomChat/RoomChat.vue';

export default {
  name: 'SideBar',
  components: {
    RoomControls,
    RoomChat,
  },
  props: {
    participants: {},
    room: {
      type: Object,
      default: () => ({}),
    },
    joiningRoom: Boolean,
    mobileSection: String,
    disabled: Boolean,
  },
  data() {
    return {
      viewingSettings: false,
    };
  },
  methods: {
    join(config) {
      this.$emit('join', config);
    },
    disconnect() {
      this.$emit('disconnect');
    },
    showing(paths) {
      paths = Array.isArray(paths) ? paths : [paths];
      return !this.isMobile || paths.includes(this.mobileSection);
    },
  },
};
</script>

<style lang="less">
.local-container {
  display: flex;
  flex-direction: column;
}
</style>
